const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/soh/Footer.tsx';
import { VersionInfo } from 'App/components/VersionInfo';
import * as React from 'react';
import CommonFooter from 'App/components/Footer/CommonFooter';
import { Link, Links } from 'App/components/Footer/Links';
import textMap from './translations';

export const Footer = (props: {}) => {
    return (
        <CommonFooter>
            <Links>
                <Link href="https://www.solothurnerspitaeler.ch/footer/impressum/" text={textMap.impressum} />
                <Link
                    href="https://www.solothurnerspitaeler.ch/footer/disclaimerdatenschutz/datenschutz-meine-soh"
                    text={textMap.disclaimer}
                />
            </Links>
            <VersionInfo />
            <div className="placeholder" />
        </CommonFooter>
    );
};

export default Footer;
